import { WorkflowStepCode } from '@exam-management/graphql';
import { LabelColor } from '@shared/components';

export const QSET_REVIEW_STATUS_COLOR = {
  [WorkflowStepCode.ReviewQsetTodo]: LabelColor.INFO,
  [WorkflowStepCode.ReviewQsetInReview]: LabelColor.WARNING,
  [WorkflowStepCode.ReviewQsetReviewed]: LabelColor.SUCCESS,
  [WorkflowStepCode.ReviewQsetDone]: LabelColor.SUCCESS,
};

export const QSET_REVIEW_STATUS_TEXT = {
  [WorkflowStepCode.ReviewQsetTodo]: 'Todo',
  [WorkflowStepCode.ReviewQsetInReview]: 'In Review',
  [WorkflowStepCode.ReviewQsetReviewed]: 'Reviewed',
  [WorkflowStepCode.ReviewQsetDone]: 'Done',
};
